import React from "react";
import { Box, Typography, Link, Button } from "@mui/material";
import { ReactComponent as MwebDhiramIcon } from "../../../../assets/svg/MwebDhiramIcon.svg";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { ReactComponent as PdfIcon } from "../../../../assets/svg/SmallPdfIcon.svg";
import { paymentStatusStyleArray } from "../../config";
import moment from "moment";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  
  if (text.toLowerCase() === "created") {
    return "-";
  }
  
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const MobileView = ({ details, handleDeleteFile, handleFileSelect }) => {
  return (
    <div style={mobileStyles.container}>
      <div style={mobileStyles.milestonesContainer}>
        {details?.[0]?.payouts?.map((item, idx) => {
          const metaData = item?.metadata ? JSON.parse(item.metadata) : null;
          const invoiceData = item?.invoice
            ? item.invoice
            : item?.invoiceUrl
            ? JSON.parse(item.invoiceUrl)
            : null;

          let invoiceStatus = null;
          if (invoiceData) {
            if (invoiceData.status) {
              invoiceStatus = invoiceData.status;
            } else {
              invoiceStatus = invoiceData.approve
                ? "APPROVED"
                : "IN_REVIEW";
            }
          }

          const fileUrl = metaData?.file?.fileUrl;

          return (
            <div key={item.id} style={mobileStyles.milestoneCard}>
              <div style={mobileStyles.milestoneHeader}>
                <div style={mobileStyles.milestoneInfo}>
                  <div style={mobileStyles.milestoneText}>
                    <Typography style={mobileStyles.milestoneLabel}>
                      Payment
                    </Typography>
                    <Typography style={mobileStyles.milestoneName}>
                      {item?.groupName}
                    </Typography>
                  </div>
                </div>
                <Box display="flex" alignItems="center" gap="5px">
                  <div style={mobileStyles.milestoneText}>
                    <Typography style={mobileStyles.milestoneName}>
                      {fileUrl && (
                        <Link
                          href={fileUrl}
                          target="_blank"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                          }}
                        >
                          <PdfIcon />
                        </Link>
                      )}
                    </Typography>
                  </div>
                </Box>
              </div>

              <div style={mobileStyles.milestoneDates}>
                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>
                    Due Date
                  </Typography>
                  <Typography style={mobileStyles.dateValue}>
                    {item?.dueDate
                      ? moment(item?.dueDate).format("MMM DD, YYYY")
                      : "-"}
                  </Typography>
                </div>

                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>Status</Typography>
                  <div style={mobileStyles.statusContainer}>
                    <div
                      style={{
                        ...mobileStyles.statusDot,
                        backgroundColor:
                          paymentStatusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "#FFAD5C",
                      }}
                    ></div>
                    <Typography style={mobileStyles.statusText}>
                      {getStatusDisplayText(item?.status || "pending")}
                    </Typography>
                  </div>
                </div>
              </div>

              <div style={mobileStyles.milestoneDates}>
                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>
                    Settled On
                  </Typography>
                  <Typography style={mobileStyles.amountValue}>
                    {item?.releaseDate
                      ? moment(item?.releaseDate).format("MMM DD, YYYY")
                      : "-"}
                  </Typography>
                </div>

                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>
                    Amount Paid
                  </Typography>
                  <Typography style={mobileStyles.amountValue}>
                    <MwebDhiramIcon />
                    &nbsp;
                    {formattedAmountWithoutAed(item?.amount || "-")}
                  </Typography>
                </div>
              </div>

              {item.groupName && item.amount !== 0 && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {!invoiceData?.url ? (
                    item.status === "DUE" && (
                      <Button
                        variant="contained"
                        component="label"
                        sx={{
                          backgroundColor: "#4D6BF6",
                          borderRadius: "12px",
                          fontSize: "14px",
                          fontWeight: 500,
                          boxShadow: "none",
                          color: "#fff",
                          border: "none",
                          padding: ".7vh 1vw",
                          cursor: "pointer",
                          fontFamily: "Inter Tight",
                          whiteSpace: "nowrap",
                          width: "100% !important",
                          "&:hover": {
                            backgroundColor: "#4D6BF6",
                            border: "none",
                          },
                        }}
                      >
                        Upload Invoice
                        <input
                          id={`pdf-upload-${item.id}`}
                          type="file"
                          accept="application/pdf"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileSelect(e, item.id)}
                        />
                      </Button>
                    )
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Link
                          href={invoiceData.url}
                          target="_blank"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                          }}
                          title="Download Invoice"
                        >
                          <PdfIcon />
                        </Link>

                        {invoiceStatus === "IN_REVIEW" && (
                          <Box
                            sx={{
                              color: "#E6A23C",
                              fontWeight: 500,
                              fontSize: "14px",
                            }}
                          >
                            In Review
                          </Box>
                        )}

                        {invoiceStatus === "APPROVED" && (
                          <Box
                            sx={{
                              color: "#28a745",
                              fontWeight: 500,
                              fontSize: "14px",
                            }}
                          >
                            Approved
                          </Box>
                        )}

                        {invoiceStatus === "REJECTED" && (
                          <Box
                            sx={{
                              color: "#D64B64",
                              fontWeight: 500,
                              fontSize: "14px",
                            }}
                          >
                            Rejected
                          </Box>
                        )}
                      </div>

                      {invoiceStatus === "REJECTED" && (
                        <Button
                          variant="outlined"
                          onClick={() =>
                            handleDeleteFile(invoiceData.blobFileId, item.id)
                          }
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            fontSize: "14px",
                            fontWeight: 500,
                            boxShadow: "none",
                            color: "#D64B64",
                            border: "1px solid #D7D8D9",
                            padding: ".5vh .8vw",
                            cursor: "pointer",
                            fontFamily: "Inter Tight",
                            whiteSpace: "nowrap",
                            width: "100%",
                            minWidth: 0,
                            "&:hover": {
                              backgroundColor: "#fff",
                              border: "1px solid #D7D8D9",
                            },
                          }}
                        >
                          Delete
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mobileStyles = {
  container: {
    padding: "2vh 0",
    backgroundColor: "#fff",
  },
  financialSummary: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "16px",
  },
  financialItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  financialLabel: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px",
  },
  financialValue: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  statusSelect: {
    minWidth: "150px",
  },
  select: {
    fontSize: "14px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  viewToggle: {
    display: "flex",
    gap: "4px",
    backgroundColor: "#f0f0f0",
    borderRadius: "8px",
    padding: "2px",
  },
  toggleButton: {
    width: "32px",
    height: "32px",
    border: "none",
    backgroundColor: "transparent",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  toggleButtonActive: {
    backgroundColor: "#0066cc",
    color: "#fff",
  },
  addMilestoneButton: {
    width: "100%",
    backgroundColor: "#0066cc",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    marginBottom: "16px",
  },
  milestonesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  milestoneCard: {
    backgroundColor: "#fff",
    borderRadius: "none",
    padding: "16px 0",
    borderBottom: "1px solid #D7D8D9",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  milestoneHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  milestoneInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  milestoneImage: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  milestoneText: {
    display: "flex",
    flexDirection: "column",
  },
  milestoneLabel: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "2px",
  },
  milestoneName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  milestoneIcon: {
    width: "20px",
    height: "20px",
  },
  milestoneDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  contractorInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  contractorAvatar: {
    width: "24px",
    height: "24px",
  },
  contractorText: {
    display: "flex",
    flexDirection: "column",
  },
  contractorLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "1px",
  },
  contractorName: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#333",
  },
  statusInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "3px solid rgb(229, 229, 229)",
  },
  statusText: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  milestoneDates: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    alignItems: "center",
    gap: "2rem",
  },

  dateItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  dateLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  dateValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  amountValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
};

export default MobileView;
